// extracted by mini-css-extract-plugin
export default {"timeview":"TimeView_timeview__8N4Ab"};